<template>
  <div>
    <div class="entete border-entete" v-if="informationRole">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3" v-if="$route.params.id === undefined">
                {{ $t('gestionRole.ajout.title') }}
              </h1>
              <h1 class="title is-size-3" v-else>
                {{ $t('gestionRole.modification.title', { role: libelle }) }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button class="button" @click="$router.go(-1)">
              {{ $t('detail.buttons.cancel') }}
            </button>
            <button class="button is-addOrEdit" @click="savePermission">
              {{ $t('general.button.sauvegarder') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <br>
    <error-msg-component :messages="messages"
                          :error="error"
                          :messagesChampsVide="messagesChampsVide"
                          :champsVide="champsVide"
                          :title="'editionClient.problemOccurred'"
                          :withEmplyFields="true"
                          @close="error = $event"/>
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t('gestionRole.role')}}
        </p>
      </header>
      <div class="card-content is-marginless">
        <div class="columns">
          <b-field class="column is-3 obligatoire" :label="$t('gestionRole.libelle')">
            <b-input type="text" v-model="informationRole.name"></b-input>
          </b-field>
          <b-field class="column is-9" :label="$t('gestionRole.description')">
            <b-input type="text" v-model="informationRole.description"></b-input>
          </b-field>
        </div>
        <app-role-manager
          :allPermission="allPermissionsExisting"
          :disable="false">
        </app-role-manager>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '@/components/general/breadcrumb';
import cloneDeep from 'lodash/cloneDeep';
import {
  getAllPermissions, create, update, getRoleForEdit,
} from '@/api/role/index';
import generationTableauDesRoles from '@/services/role/generationTableauDesRoles';
import roleManager from '@/components/role/roleManager';
import getPermissionSelected from '@/services/role/getPermissionSelected';
import transfertCategoriePermission from '@/services/role/transfertCategoriePermissions';
import genererRole from '@/services/role/genererRole';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/role/validation/champsRoleTranslator';
import messageSuccess from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import { MODULES, DROITS, CATEGORIE_TO_TRANSFERT } from '@/configuration/role/roleManagerConf';
import mergePermission from '@/services/role/mergePermission';
import errorMsgComponent from '@/components/general/errorMsgComponent';

export default {
  name: 'm_gestionRole',
  data() {
    return {
      allPermissionsExisting: [],
      permissionDuRole: [],
      informationRole: genererRole(),
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
      libelle: '',
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    appRoleManager: roleManager,
    errorMsgComponent,
  },
  methods: {
    async savePermission() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.informationRole.grantedPermissions = await getPermissionSelected(
          this.allPermissionsExisting,
        );
        // Attention!!!!
        // Le test a été fait dans le front car la gestion du role coté back
        // est totalement fait par Abp
        // Et sa validation ne peut être changé (du moins pas sans tout refaire)
        // !!!!!
        if (this.informationRole.grantedPermissions.length === 0) {
          this.messages = [];
          this.messages.push(this.$t('gestionRole.errorPermissions'));
          this.error = true;
          loadingComponent.close();
          return;
        }
        let response = null;
        let message = null;
        this.informationRole.displayName = this.informationRole.name;
        if (this.$route.params.id !== undefined) {
          response = await update(this.informationRole);
          message = this.$t('gestionRole.successModification');
        } else {
          response = await create(this.informationRole);
          message = this.$t('gestionRole.successCreation');
        }
        loadingComponent.close();
        messageSuccess(message);
        this.$router.push({ name: 'c.parametrage.roles', params: { id: response.data.result.id } });
      } catch (e) {
        loadingComponent.close();
        if (e.response.data.success === false) {
          this.messages = [];
          if (e.response.data.error.validationErrors === null) {
            // ajout du message ici car le systeme back ne me renvoie pas la meme structure pour
            // les messages d'erreur
            this.messages.push({
              message: 'gestionRole.errorLibelle',
            });
            this.error = true;
          } else {
            await this.loadError(e.response);
          }
        } else {
          messageErreur(this.$i18n);
        }
        throw e;
      }
    },
    loadError(response) {
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.messages = [];
      validationGeneral(this.$i18n, response, this.champsVide, this.messages,
        this.messagesChampsVide, translate);
      this.error = true;
    },
  },
  computed: {
    breadcrumb() {
      const output = [
        { title: this.$t('parametrage.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('parametrage.title'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('role.title'), route: { name: 'l.parametrage.roles' }, isActive: false },
        { title: this.$t('gestionRole.ajout.title'), route: '', isActive: true },
      ];
      if (this.$route.params.id) {
        output[3].title = this.$t('gestionRole.modification.title', { role: this.libell });
      }
      return output;
    },
  },
  async beforeMount() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.$route.params.id !== undefined) {
        const informationDuRole = (await getRoleForEdit(this.$route.params.id)).data.result;
        this.setInformationPage(this.$t('pageGeneral.modification', { item: informationDuRole.role.name }));
        this.allPermissionsExisting = await generationTableauDesRoles(
          informationDuRole.permissions,
          MODULES,
          DROITS,
        );
        this.informationRole = informationDuRole.role;
        this.libelle = cloneDeep(this.informationRole.name);
        this.permissionDuRole = informationDuRole.grantedPermissionNames;
      } else {
        this.setInformationPage(this.$t('pageParametrage.role.creation'));
        this.allPermissionsExisting = await generationTableauDesRoles(
          (await getAllPermissions()).data.result.items,
          MODULES,
          DROITS,
        );
      }
      transfertCategoriePermission(this.allPermissionsExisting,
        CATEGORIE_TO_TRANSFERT);
      this.allPermissionsExisting = mergePermission(
        this.allPermissionsExisting,
        this.permissionDuRole,
      );
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
